import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect, useMemo } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  COMMUNITY_NAME,
  YEAR,
  METRIC_TYPE,
  TYPE,
  METRIC_STATUS,
} from "./consts";
import { ACTUALS, PLANNED, SQUARE_FOOTAGE, WEIGHING_FACTOR } from "@/lib/utils";

const useDistributionMetricsMaintenance = () => {
  const { communityData, currentFinanceYear, metricData } = useSelector(
    (state: RootState) => state.currentData
  );

  const form = useForm({
    defaultValues: {
      [COMMUNITY_NAME]:
        communityData?.communityName?.toString() ||
        communityData?.name?.toString() ||
        "",
      [YEAR]: currentFinanceYear,
      [METRIC_TYPE]: SQUARE_FOOTAGE,
      [TYPE]: ACTUALS
    },
  });

  const metricType = useWatch({control: form.control, name: METRIC_TYPE});
  const activeType = useWatch({control: form.control, name: TYPE});

  const isWeighingFactor = useMemo(() => metricType === WEIGHING_FACTOR, [metricType]);
  
  useEffect(() => {
    form.setValue(TYPE, metricType == WEIGHING_FACTOR ? PLANNED : ACTUALS as any);
  }, [metricType]);
  
  const communityName =
    communityData?.communityName || communityData?.name || "";

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.bom}/${routes.finance}`,
        name: `Activity Dashboard - ${communityName}`,
      },
      {
        link: `/${routes.bom}/${routes.finance}/${routes.costAnalytics}`,
        name: `Cost Analytics`,
      },
      {
        link: "",
        name: (
          <span className="text-primary">Allocation Metrics Maintenance</span>
        ),
      },
    ],
    [communityName]
  );

  const metricStatus = useMemo(() => 
    METRIC_STATUS?.map((data: any) => ({
      ...data,
      value: metricData?.data?.[data.key] ? data?.label?.toLowerCase()?.includes("total") ? Number(metricData?.data[data.key]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : String(metricData?.data?.[data.key]).padStart(2, "0") : "00"
    }))
  ,[metricData]);

  return {
    breadcrumbData,
    year: currentFinanceYear,
    metricType,
    metricStatus,
    form,
    isWeighingFactor,
    activeType
  };
};

export default useDistributionMetricsMaintenance;
